export enum QqTypeEnum {
    slider = "slider",
    dropdown="dropdown",
    checkbox="checkbox"
}